(() => {
  const INIT_ATTR = 'data-hinge-ready';

  function initHingeCarousel(root) {
    if (!root || root.hasAttribute(INIT_ATTR)) return;

    const tabs = Array.from(root.querySelectorAll('[data-hinge-tab]'));
    const slides = Array.from(root.querySelectorAll('.hinge-carousel__slide'));
    const prevBtn = root.querySelector('[data-hinge-prev]');
    const nextBtn = root.querySelector('[data-hinge-next]');
    if (!slides.length) return;

    root.setAttribute(INIT_ATTR, 'true');

    let index = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );

    const goTo = (nextIndex) => {
      index = ((nextIndex % slides.length) + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        goTo(Number(tab.dataset.index || 0));
      });
    });

    prevBtn?.addEventListener('click', () => goTo(index - 1));
    nextBtn?.addEventListener('click', () => goTo(index + 1));

    goTo(index);
  }

  function initAll() {
    document.querySelectorAll('[data-hinge-carousel]').forEach(initHingeCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
